/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import { OnmaxContext } from "../OnmaxContext";

export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  const [referral, setReferral] = useState("");
  const [telegram, setTelegram] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);

  const { toastSuccess, toastError } = useContext(OnmaxContext);

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toastError("Passwords do not match");
      return;
    }

    try {
      setIsRegistering(true); // 🔒 disable button

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "insert",
        key: process.env.REACT_APP_KEY,
        ref_address: referral,
        fromname: name,
        email: telegram,
        password: password,
      });

      const result = res.data;

      if (result.resCode !== 200) {
        toastError(result.error);
        return;
      }

      toastSuccess(result.message || "Registered Successfully");
      localStorage.setItem("email", telegram);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      navigate("/verify");
    } catch (error) {
      toastError(error.response?.data?.message || "Error during registration");
    } finally {
      setIsRegistering(false); // 🔓 enable button again
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refFromUrl = params.get("ref");

    if (refFromUrl) {
      setReferral(refFromUrl); // auto fill
    }
  }, [location.search]);

  const customStyles = `
    .ai-auth-container {
        min-height: 100vh;
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        position: relative;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        position: relative;
        z-index: 10;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }
    
    .ai-logo-glow {
        filter: drop-shadow(0 4px 10px rgba(0, 111, 227, 0.2));
        margin-bottom: 24px;
        transition: filter 0.3s;
        border-radius: 12px;
    }

    .ai-auth-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; letter-spacing: 0.5px;}
    .ai-auth-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; font-weight: 500;}

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 16px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      position: relative;
      transition: all 0.3s;
      margin-bottom: 24px;
    }
    .db-input-wrapper:focus-within {
       border-color: #006fe3;
    }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }
    .db-input::placeholder { color: #94a3b8; font-weight: 500; }
    
    .tc-scroll-container {
       border: 1px solid rgba(0, 111, 227, 0.15);
       border-radius: 12px;
       margin-bottom: 20px;
       overflow: hidden;
       box-shadow: 0 4px 15px rgba(0,0,0,0.02);
    }
    .tc-box {
       background: rgba(238, 242, 246, 0.7);
       padding: 20px;
       height: 120px;
       overflow-y: auto;
       color: #64748b;
       font-size: 13px;
       line-height: 1.6;
    }
    .tc-box::-webkit-scrollbar { width: 6px; }
    .tc-box::-webkit-scrollbar-track { background: transparent; }
    .tc-box::-webkit-scrollbar-thumb { background: #006fe3; border-radius: 10px; }
    .tc-title { color: #1a2234; font-weight: 800; font-size: 14px; margin-bottom: 12px; }

    .tc-check-area {
       display: flex; align-items: center; gap: 14px; 
       background: #ffffff;
       border: 1px solid rgba(0, 111, 227, 0.2);
       box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
       padding: 16px 20px;
       border-radius: 12px;
       margin-bottom: 30px;
    }
    .tc-check-label { color: #475569; font-size: 14px; font-weight: 600; cursor: pointer; user-select: none; margin: 0; }
    .tc-check-link { color: #006fe3; text-decoration: none; font-weight: 800; margin-left: 5px; }
    
    input[type="checkbox"].tc-checkbox {
       width: 20px; height: 20px; accent-color: #006fe3; cursor: pointer; margin: 0;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 14px;
      font-weight: 700; width: 100%; font-size: 16px; letter-spacing: 1px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.4); transition: 0.3s; text-transform: uppercase;
      display: flex; align-items: center; justify-content: center; gap: 8px;
    }
    .db-modern-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 111, 227, 0.5); }
    .db-modern-btn:disabled { opacity: 0.7; cursor: not-allowed; }

    .ai-switch-text { text-align: center; margin-top: 24px; color: #64748b; font-size: 14px; font-weight: 600;}
    .ai-switch-link { color: #006fe3; font-weight: 800; cursor: pointer; margin-left: 5px; text-decoration: none; }
    .ai-switch-link:hover { text-decoration: underline; }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="ai-auth-container">
        {/* Brand Logo */}
        <div className="text-center">
          <img
            src="assets/logo_dark.svg"
            alt="Logo"
            className="ai-logo-glow"
            width="180"
          />
        </div>

        <div className="ai-auth-card">
          <h2 className="ai-auth-title">Create Account</h2>
          <p className="ai-auth-subtitle">Sign up to start your journey</p>

          <form onSubmit={handleRegister}>
            <div className={`db-input-wrapper ${referral ? 'disabled' : ''}`} style={referral ? { opacity: 0.7, backgroundColor: '#f1f5f9' } : {}}>
              <span className="db-input-icon-box">
                <i className="fa fa-user-plus" style={{ color: '#64748b' }}></i>
              </span>
              <input
                className="db-input"
                type="text"
                placeholder="Referral ID"
                value={referral}
                onChange={(e) => setReferral(e.target.value)}
                disabled={!!referral}
                required
              />
            </div>

            <div className="db-input-wrapper">
              <span className="db-input-icon-box">
                <i className="fa fa-envelope" style={{ color: '#64748b' }}></i>
              </span>
              <input
                className="db-input"
                type="text"
                placeholder="Email Address"
                value={telegram}
                onChange={(e) => setTelegram(e.target.value)}
                required
              />
            </div>

            <div className="db-input-wrapper">
              <span className="db-input-icon-box">
                <i className="fa fa-user" style={{ color: '#64748b' }}></i>
              </span>
              <input
                className="db-input"
                type="text"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="db-input-wrapper">
              <span className="db-input-icon-box">
                <i className="fa fa-lock" style={{ color: '#64748b' }}></i>
              </span>
              <input
                className="db-input"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="db-input-wrapper">
              <span className="db-input-icon-box">
                <i className="fa fa-shield-alt" style={{ color: '#64748b' }}></i>
              </span>
              <input
                className="db-input"
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            {/* T&C Scrollable Policy Box */}
            {/* <div className="tc-scroll-container">
              <div className="tc-box">
                <div className="tc-title">Terms & Conditions – Investment Disclaimer</div>
                Cryptocurrency investments are subject to high market risks, including the possible loss of invested capital. Returns are not guaranteed, and past performance does not represent or assure future results. Digital asset prices may be highly volatile and can fluctuate significantly due to market conditions, regulatory changes, and other external factors. <br /><br />
                Investors are strongly advised to carefully read all scheme-related documents, understand the associated risks, and conduct their own independent research before making any decisions. By proceeding, you acknowledge these risks and agree to our privacy policies.
              </div>
            </div> */}

            {/* Checkbox separate block */}
            {/* <div className="tc-check-area">
              <input type="checkbox" id="tcCheck" className="tc-checkbox" required />
              <label htmlFor="tcCheck" className="tc-check-label">
                I accept the <span className="tc-check-link">Terms & Conditions</span>
              </label>
            </div> */}

            <button type="submit" className="db-modern-btn" disabled={isRegistering}>
              {isRegistering ? "Creating Account..." : "Sign Up"}
            </button>

            <div className="ai-switch-text">
              Already have an account?
              <span className="ai-switch-link" onClick={() => navigate("/")}>Log in</span>
            </div>
          </form>
        </div>

        <div style={{ padding: '20px', color: '#64748b', fontSize: 12 }}>
          &copy; {new Date().getFullYear()} GetLinker. All rights reserved.
        </div>
      </div>
    </>
  );
}
